// src/pages/ConfirmEmail.jsx

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function ConfirmEmail() {
  const [params] = useSearchParams();

  const API = process.env.REACT_APP_API_URL || "https://vartasocial.com/api";

  useEffect(() => {
    const token = params.get("token");

    if (!token) return;

    // Clear any old session
    localStorage.clear();

    // Redirect to backend for confirmation
    window.location.href = `${API}/confirm-email?token=${token}`;
  }, [params, API]);

  return (
    <div style={{ textAlign: "center", marginTop: 80 }}>
      <h2>Verifying your email...</h2>
    </div>
  );
}